import CardRecommendation from './CardRecommendation';

export default CardRecommendation;
